import { render } from "./ReservationsView.vue?vue&type=template&id=160b10b8&scoped=true"
import script from "./ReservationsView.vue?vue&type=script&lang=js"
export * from "./ReservationsView.vue?vue&type=script&lang=js"

import "./ReservationsView.vue?vue&type=style&index=0&id=160b10b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160b10b8"]])

export default __exports__